import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.app.header;

const getPageTitle = createSelector(getData, title => title);

export default getPageTitle;



// WEBPACK FOOTER //
// ./src/_selectors/appSelectors/getPageTitle.js